
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import LazyImg from '@/components/lazyImg/index.vue'
import LatestHomeworkSubmitCard from './card/LatestHomeworkSubmitCard.vue'
import MaxLessonWatchCard from './card/MaxLessonWatchCard.vue'
import CompleteLiveWatchCard from './card/CompleteLiveWatchCard.vue'
import EarliestHomeworkSubmitCard from './card/EarliestHomeworkSubmitCard.vue'
import MaxWordsHomeworkCard from './card/MaxWordsHomeworkCard.vue'
import MaxInteractionCard from './card/MaxInteractionCard.vue'
import ContinuousSubmitCard from './card/ContinuousSubmitCard.vue'
import MaxCommentsCard from './card/MaxCommentsCard.vue'
import MaxLikesCard from './card/MaxLikesCard.vue'
import MaxCollectsCard from './card/MaxCollectsCard.vue'
import CompleteStudyInTimeCard from './card/CompleteStudyInTimeCard.vue'
import MaxCommentInteractionsCard from './card/MaxCommentInteractionsCard.vue'
import MaxLikeInteractionsCard from './card/MaxLikeInteractionsCard.vue'
import MaxBeLikedInteractionsCard from './card/MaxBeLikedInteractionsCard.vue'
import MaxCollectInteractionsCard from './card/MaxCollectInteractionsCard.vue'
import MaxStudyDurationCard from './card/MaxStudyDurationCard.vue'
import UninterruptedCourseWatchCard from './card/UninterruptedCourseWatchCard.vue'
import UninterruptedDailySubmitCard from './card/UninterruptedDailySubmitCard.vue'
import { Observer } from 'mobx-vue'

@Observer
@Component({
  components: {
    LazyImg,
    LatestHomeworkSubmitCard,
    MaxLessonWatchCard,
    CompleteLiveWatchCard,
    EarliestHomeworkSubmitCard,
    MaxWordsHomeworkCard,
    MaxInteractionCard,
    ContinuousSubmitCard,
    MaxCommentsCard,
    MaxLikesCard,
    MaxCollectsCard,
    CompleteStudyInTimeCard,
    MaxCommentInteractionsCard,
    MaxLikeInteractionsCard,
    MaxBeLikedInteractionsCard,
    MaxCollectInteractionsCard,
    MaxStudyDurationCard,
    UninterruptedCourseWatchCard,
    UninterruptedDailySubmitCard
  }
})
export default class SummaryStudyRecord extends Vue {
  handleClickRefresh(index: number) {
    this.PageStore.onClickRefresh(index)
  }

  handleRefresh() {
    this.PageStore.refreshRecordData()
  }

  get PageStore() {
    return this.$store.$courseV2.Summary
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
